import PageContainer from "@/common/components/PageContainer";
import { AspectRatio, Box, Divider, Grid, Text, Title, createStyles } from "@mantine/core";
import { motion } from "framer-motion";
import Image from "next/image";
import { useRouter } from "next/router";
import React from "react";

import { useFetchEcompage } from "@/apis/queryFunctions/ecompagesFunctions";
import TitleCus from "@/common/Typography/TitleCus";
import useWindowSize from "@/hooks/useWindowSize";
import { useLocalContext } from "@/setup/locale-provider";
import appendImageUrlFromAPI from "@/utils/appendImageUrlFromAPI";
import sanitizeDOMData from "@/utils/sanitizeDOMData";

export default function Info({
  title = "Why to choose",
  label,
  picture = "https://zengroup.com.vn/wp-content/uploads/2022/04/du-an-nha-mat-tien-Q12-1024x768.jpg",
  index,
}) {
  let link = picture || null;
  if (link != null) {
    if (link && link.indexOf("http") < 0) {
      link = `${process.env.server_url_report}${link}?access_token=${process.env.public_token}&trustkey=${process.env.trustkey}`;
    }
  }
  const {isTablet} = useWindowSize();
  const { getLabel } = useLocalContext();
  const { locale } = useRouter();
  const { data } = useFetchEcompage("trang-noi-dia-viet-thien", locale);
  const infoNoidia = (data?.add_on_data||[]).slice(0,5);
  return (
    <Box component="section">

      <Box
          sx={{ paddingBottom:"20px" }}
      >
        <Divider my="xs" 
              label={
                <Title
                  order={1}
                  size={isTablet?24:36}
                  weight={950}
                  align="center"
                  pb={10}
                  sx={(theme) => ({ /* paddingBottom: 45, */ color: "#12854F" /* theme.colors.main[5] */ })}
                  >
                  {sanitizeDOMData(infoNoidia?.[0]?.title)}
                </Title>} 
              
              labelPosition="center" 
        />

              <Grid justify="space-between" align="center">
                {infoNoidia.slice(1,4).map((info, index) => (
                  <Grid.Col xs={12} md={3} align="center" key={index}>
                    <motion.div whileHover={{ scale: 1.05 }}>
                      <Box>
                        <Image
                          src={appendImageUrlFromAPI({
                            src: info?.picture,
                            size: "l",
                          })}
                          alt={`${info?.title}`}
                          width={128}
                          height={128}
                        />
                        <div>
                          <Text size={36} weight={950} style={{}}>
                            {sanitizeDOMData(info.title)}
                          </Text>
                          <Text size={24} weight={450}>
                            {sanitizeDOMData(info?.content)}
                          </Text>
                        </div>
                      </Box>
                    </motion.div>
                  </Grid.Col>
                ))}
              </Grid>


      </Box>

      
      <Box sx={{ paddingBottom: "20px"}}>
        <Divider my="xs" 
              label={
                <Text
                  size={36}
                  weight={950}
                  align="center"
                  pb={10}
                  sx={(theme) => ({ /* paddingBottom: 45, */ color: "#12854F" /* theme.colors.main[5] */ })}
                  >
                  {sanitizeDOMData(infoNoidia?.[4]?.title)}
                </Text>} 
              
              labelPosition="center" 
        />
        
        <Box sx={{padding:"30px 0 30px 0"}} >
                <AspectRatio ratio={16/9}>
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15672.58745657534!2d106.66630370413816!3d10.876432277921307!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3175293ed8e2cfbb%3A0xa54be615e08688f6!2zTsOUTkcgU-G6ok4gVknhu4ZUIFRIScOKTg!5e0!3m2!1sen!2s!4v1688366521053!5m2!1sen!2s"
                    title="Google map"
                    frameBorder="0"
                  />
                </AspectRatio>
        </Box>

        <Text
          size={18}
          style={{  lineHeight: "40px" }}
          align="justify"
        >
          {/* {label && getLabel(sanitizeDOMData(label))} */}
          {sanitizeDOMData(infoNoidia?.[4]?.content)}
        </Text>
      </Box>
    </Box>
  );
}
